import { configureChains } from 'wagmi';

import { infuraProvider } from 'wagmi/providers/infura';
import { publicProvider } from 'wagmi/providers/public';

import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';

import { mainnet, goerli, polygon } from 'wagmi/chains';

const defaultChains = [mainnet, goerli];

// API key for Ethereum node
// Two popular services are Infura (infura.io) and Alchemy (alchemy.com)
const infuraId = 'd1c247037b6b45848cc06359015d37e6'; // process.env.INFURA_ID;

// Configure chains for connectors to support
const { chains } = configureChains(defaultChains, [infuraProvider({ infuraId }), publicProvider()]);

// Set up connectors
export const connectors = [
  new CoinbaseWalletConnector({
    chains,
    options: {
      appName: 'Faceless',
    },
  }),
  new WalletConnectConnector({
    chains,
    options: {
      infuraId,
      qrcode: true,
    },
  }),
  new MetaMaskConnector({
    chains,
  }),
];
